import styled from 'styled-components';
import { ChipProps } from './Chip';
import { CHIP_VARIANTS } from './Chip.constants';

export const ChipContainer = styled.button<ChipProps>`
  background: none;
  border: none;
  padding: 0;
  width: fit-content;
  font-family: inherit;
  cursor: pointer;

  border: ${({ theme }) => `solid 1px ${theme.configs.CTAButton.bgColor}`};
  color: ${({ theme, variant }) => {
    return variant === CHIP_VARIANTS.fulfilled
      ? theme.configs.CTAButton.fontColor
      : theme.configs.CTAButton.bgColor;
  }};
  background-color: ${({ theme, variant }) => {
    return variant === CHIP_VARIANTS.fulfilled
      ? theme.configs.CTAButton.bgColor
      : theme.configs.CTAButton.fontColor;
  }};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  width: auto;
  display: inline-block;
  padding: 3px 6px;
  border-radius: 100px;
`;
